import VideoDisclaimer from './VideoDisclaimer';
export default VideoDisclaimer;